import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/service_provider_withdraw_application_statistics',
  component: Management,
  redirect: '/service_provider_withdraw_application_statistics/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/service_provider_withdraw_application_statistics/List'),
      meta: {
        auth: Auth.spWithdrawApplicationsMonthlySummary
      },
      redirect: '/service_provider_withdraw_application_statistics/list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/service_provider_withdraw_application_statistics/ListTable'),
          meta: {
            auth: Auth.spWithdrawApplicationsMonthlySummary,
            activeMenu: '/service_provider_withdraw_applications',
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
